import { AbcAccordionComponent, GalleryModel } from '@barthauer/abc/ui-components';
import { Item } from 'devextreme/ui/accordion';
import { DataFormService } from '../../data-form.service';
import { DataFormSettings } from '../settings.model';
import { UiCreatorBase } from './ui-creator-base';
export class AbcAccordionUiCreator extends UiCreatorBase {
  constructor(
    private service: DataFormService,
    private settings: DataFormSettings,
  ) {
    super(service, settings);
  }

  public async create(dataSource?: Item[] | GalleryModel[]): Promise<HTMLElement> {
    const cpt = this.service.abcContainer.createComponent(this.tabsDirective, AbcAccordionComponent);

    const componentInstance = cpt.componentRef.instance as AbcAccordionComponent;
    componentInstance.items = <Item[]>dataSource ?? this.settings.accordionDataSource ?? [];
    componentInstance.multiple = true;
    componentInstance.collapsible = true;
    componentInstance.deferRendering = false;
    componentInstance.animationDuration = 400;

    const domElement = cpt.domElement;
    domElement.id = 'accordionInDataForm';
    domElement.style.height = '100%';
    domElement.style.overflow = 'auto';
    domElement.style.background = 'unset';

    if (!dataSource) {
      this.settings.abcAccordionCptRef = {
        componentRef: cpt.componentRef,
        domElement: cpt.domElement,
      };
    }
    return domElement;
  }

  public update(identifier: string): void {
    const accordion: AbcAccordionComponent = this.settings.abcAccordionCptRef?.componentRef
      ?.instance as AbcAccordionComponent;
    if (accordion) {
      accordion.items.forEach((item: Item) => {
        const propName = 'is' + identifier + 'Checked';
        const isChecked = this.settings[propName];
        if (item.text === identifier) {
          item.visible = isChecked;
        }
      });
    }
  }

  public add() {
    // TODO if needed, add an element to the Accordion
    return;
  }

  public remove() {
    // TODO if needed, remove an element from the Accordion
    return;
  }
}
